import { render } from "./News.vue?vue&type=template&id=69905df5"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
script.render = render

export default script